export enum UserDetailsTabTypeEnum {
    SETTINGS = 'settings',
    PROJECTS = 'projects',
    BILLING = 'billing',
}
